import { ChangeDetectionStrategy, Component, inject, Input, signal, Signal } from '@angular/core';
import { AvatarUser } from '@app/shared/components/user-avatar-with-extended-info/types';
import { getTranslationProvider } from '@core/i18n/getTranslationProvider';
import { TranslatableComponent } from '@core/i18n/TranslatableComponent';
import { LundifySubscriptionUser } from '@core/state/types/lundify-subscription-response.types';
import { LundifyUsersFacade } from '../services/lundify-users.facade';
import { ClientType } from 'src/app/core/state/types';
import { LundifySubscriptionFacade } from '../services/lundify-subscription.facade';

@Component({
  selector: 'app-subscription-users',
  templateUrl: './users.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [getTranslationProvider('UsersComponent')],
})
export class UsersComponent extends TranslatableComponent {
  @Input() client: ClientType;

  private lundifyUsersFacade = inject(LundifyUsersFacade);
  private lundifySubscriptionFacade = inject(LundifySubscriptionFacade);

  get admins(): AvatarUser[] {
    return this.toAvatarUsers(this.lundifyUsersFacade.adminUsers());
  }

  get users(): AvatarUser[] {
    return this.toAvatarUsers(this.lundifyUsersFacade.collaboratorUsers());
  }

  get isLoading(): Signal<boolean> {
    return this.lundifyUsersFacade.isLoading;
  }

  get isCurrentUserClientResponsibleOrAdmin(): Signal<boolean> {
    if (!this.client) {
      return signal(false);
    }
    return this.lundifySubscriptionFacade.hasPermissionToEdit(this.client.responsible?.id);
  }

  openAddAdminDialog(): void {
    this.lundifyUsersFacade.openAddAdminDialog(this.client, this.lundifySubscriptionFacade.isAnnualBundle());
  }

  private toAvatarUsers(users: LundifySubscriptionUser[]): AvatarUser[] {
    return users.map((user) => ({
      id: user.id,
      name: user.name,
      initials: user.name.charAt(0).toUpperCase(),
      email: user.email,
      role: user.role as 'admin' | 'user',
      roleText: this.translate(user.role.toLowerCase()),
      socialSecurityNumber: user.socialSecurityNumber,
    }));
  }
}
